// Import Dependencies
import React from 'react';
// Import Local Styles
import styles from './modal.module.css';
import { CloseIcon } from '../SvgIcons';
import { MODAL_TYPES } from '~/common/consts';

type ModalProps = {
  onCloseCallBack?: any;
  children: JSX.Element;
  customStyles?: string;
};

export const TrialModal = (props: ModalProps) => {
  const { onCloseCallBack, children } = props;
  const modalType = window.TrialForm?.modalType;

  function closeModal() {
    if (modalType === MODAL_TYPES.UNIFIED) return;
    // if modal is closable, close it.
    if (onCloseCallBack) onCloseCallBack();
  }

  return (
    <>
      <div
        className={styles.blocker}
        onClick={() => closeModal()}
        style={{
          backgroundImage:
            modalType === MODAL_TYPES.UNIFIED
              ? `url('https://www.lastpass.com/-/media/abe7220932c4494a9bd7d73722e73109.ashx')`
              : '',
        }}
      >
        <div
          className={`${styles.modal} ${styles[modalType === MODAL_TYPES.UNIFIED ? 'unified' : '']}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles['modal-wrap']}>{children}</div>
          {modalType !== MODAL_TYPES.UNIFIED && (
            <button onClick={() => closeModal()} className={styles.close}>
              <CloseIcon />
            </button>
          )}
        </div>
      </div>
    </>
  );
};
